<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title>
			<v-form @submit.prevent="load" class="form-inline">
				<v-row class="">
					<v-col cols="12" class="d-flex flex-wrap align-center">
						<v-text-field
							outlined
							class="search-field-name mr-2"
							dense
							v-model="query.bean_name"
							label="豆名"
							hide-details
						/>
						<v-text-field
							outlined
							class="search-field-date mr-2"
							dense
							v-model="query.date"
							label="日期"
							hide-details
						/>
						<v-select
							outlined
							class="mr-2"
							dense
							label="库存类型"
							v-model="query.type"
							:items="refs['StockLogType']"
							hide-details
							clearable
						></v-select>
						<v-select
							outlined
							class="mr-2"
							dense
							label="豆类型"
							v-model="query.bean_type"
							:items="refs['BeanType']"
							hide-details
							clearable
						></v-select>
						<v-btn color="primary" size="large" class="mr-2" @click="load">查询</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>

		<v-card-text class="pt-0">
			<v-data-table-server
				:headers="headers"
				:items="objects"
				@update:options="load"
				multi-sort
				:items-length="parseInt(total)"
				:loading="loading"
				:show-select="showSelect"
				:single-select="singleSelect"
				v-model="selected"
			>
				<template v-slot:top>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>

				<template v-slot:item.created_at="{ item }">{{ $formatTime(item.created_at) }}</template>
				<template v-slot:item.qty="{ item }">
					<span v-if="item.toqty - item.fromqty > 0" style="color: green">
						{{ item.qty }}
						<span
							style="font-size: 0.6rem"
							v-if="parseFloat(item.toqty) - parseFloat(item.fromqty) !== parseFloat(item.qty)"
						>
							??
						</span>
					</span>
					<span v-else style="color: red">
						{{ item.qty }}
					</span>
					<span style="font-size: 0.6rem">{{ item.fromqty }} => {{ item.toqty }}</span>
				</template>
				<template v-slot:item.type="{ item }">
					<enum-chip kind="stockLogType" :value="item.type" />
				</template>
				<template v-slot:item.bean_type="{ item }">
					<enum-chip kind="beanType" :value="item.bean_type" />
				</template>
				<template v-slot:item.status="{ item }">
					<enum-chip kind="status" :value="item.status" />
				</template>
				<template v-slot:item.bean="{ item }">{{ item.bean?.name }}</template>
				<template v-slot:item.src_type="{ item }">
					{{ srcTypeLabel(item.src_type) }}
					<template v-if="item.src_id">（{{ item.src_id }}）</template>
				</template>
				<template v-slot:item.action="{ item }">
					<slot name="actions" v-bind:item="item"></slot>
				</template>

				<template v-slot:footer>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>
			</v-data-table-server>
		</v-card-text>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'
import EnumChip from '../common/EnumChip.vue'
import { enumLabel, STOCK_SRC_LABELS } from '../common/enumLabels'

export default {
	components: { EnumChip },
	props: {
		beanId: { type: [Number, String], default: null },
		type: { type: String, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '日期', align: 'left', sortable: true, value: 'created_at' },
				{ title: '豆类型', sortable: true, value: 'bean_type' },
				{ title: '豆', sortable: true, value: 'bean' },
				{ title: '库存类型', sortable: true, value: 'type' },
				{ title: '数量', sortable: true, value: 'qty' },
				{ title: '来源', sortable: true, value: 'src_type' },
				{ title: '状态', sortable: true, value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		return {
			query: {},
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('bean', 'BeanType,StockLogType', (res) => {
			this.refs = res
		})
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		// options: {
		// 	handler() {
		// 		this.load()
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		srcTypeLabel(value) {
			return enumLabel(STOCK_SRC_LABELS, value)
		},
		reset() {
			this.query = {}
		},
		load(options = {}) {
			let { sortBy, page, itemsPerPage } = options

			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)
			if (this.beanId) qwp['bean_id'] = this.beanId
			this.$api.bean.searchStockLog(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
